function cycchooseyearins(val){

  if(val == 'Select Year'){
    searchyear ='';
  }else{
    searchyear = val;
	searchmake='';
	searchmodel='';
	cycgetdropdownins();
  }
  
}

function cycchoosemakeins(val){

  if(val == 'Select Make'){
    searchmake ='';
  }else{
    searchmake = val;
	searchmodel='';
	cycgetdropdownins();
  }

}

function cycchoosemodelsearchins(val){

  if(val == 'Select Model'){
    searchmodel ='';
  }else{
    searchmodel = val;
	window.location ='/pages/search-instructions?searchyear=' + searchyear + '&searchmake=' + searchmake + '&searchmodel=' + encodeURIComponent(searchmodel);
  }

}



function cycgetdropdownins(){
        var jsel = document.createElement('script');
        jsel.type = 'text/javascript';
        jsel.src = 'https://myaccount.carandtruckremotes.com/cyc/searchinstructions/populate-search-ins-sp.php?searchyear=' + searchyear + '&searchmake=' + searchmake + '&searchmodel=' + searchmodel;
		
		if (document.getElementById('cyc-ajax-load-ins')){
            document.getElementById('cyc-ajax-load-ins').appendChild (jsel);
        }
}

function cycgetdropdowninsjs(){
        var jsel = document.createElement('script');
        jsel.type = 'text/javascript';
        jsel.src = 'https://myaccount.carandtruckremotes.com/cyc/searchinstructions/yearshp.js';
		
		if (document.getElementById('cyc-ajax-load-ins')){
            document.getElementById('cyc-ajax-load-ins').appendChild (jsel);
        }
}

function cycdropdowninsint(){

  cycgetdropdowninsjs();
}

function cycdropsearchfind(){
  $(".cycsearchmsgins").html('');
  if($(".cycsearchmainins .cycsearchyearins").val().startsWith('Select') == true){
	 $(".cycsearchmainins .cycsearchyearins").css("color","#E32028");   
	 $(".cycsearchmsgins").append('<DIV style="margin-top:4px;font-size:1.2em;color:#FFFFFF;text-align:center;font-family: Metropolis;">Enter Year</DIV>');
  }
  
  if($(".cycsearchmainins .cycsearchmakinse").val().startsWith('Select') == true){
	 $(".cycsearchmainins .cycsearchmakeins").css("color","#E32028");   
	 $(".cycsearchmsgins").append('<DIV style="margin-top:4px;font-size:1.2em;color:#FFFFFF;text-align:center;font-family: Metropolis;">Enter Make</DIV>');
  }
  
  if($(".cycsearchmainins .cycsearchmodelins").val().startsWith('Select') == true){
	 $(".cycsearchmainins .cycsearchmodelins").css("color","#E32028");   
	 $(".cycsearchmsgins").append('<DIV style="margin-top:4px;font-size:1.2em;color:#FFFFFF;text-align:center;font-family: Metropolis;">Enter Model</DIV>');
  }
  
}
function cycdropsearchfindMins(){
  $(".cycsearchmsgmins").html('');
  if($(".cycsearchmainins .cycsearchyearmins").val().startsWith('Select') == true){
	 $(".cycsearchmainins .cycsearchyearmins").css("color","#E32028");   
	 $(".cycsearchmsgmins").append('<DIV style="margin-top:4px;font-size:1.2em;color:#FFFFFF;text-align:center;font-family: Metropolis;">Enter Year</DIV>');
  }
  
  if($(".cycsearchmainins .cycsearchmakemins").val().startsWith('Select') == true){
	 $(".cycsearchmainins .cycsearchmakemins").css("color","#E32028");   
	 $(".cycsearchmsgmins").append('<DIV style="margin-top:4px;font-size:1.2em;color:#FFFFFF;text-align:center;font-family: Metropolis;">Enter Make</DIV>');
  }
  
  if($(".cycsearchmainins .cycsearchmodelmins").val().startsWith('Select') == true){
	 $(".cycsearchmainins .cycsearchmodelmins").css("color","#E32028");   
	 $(".cycsearchmsgmins").append('<DIV style="margin-top:4px;font-size:1.2em;color:#FFFFFF;text-align:center;font-family: Metropolis;">Enter Model</DIV>');
  }
  
}

function cyclandingdropsearchfind(){
  if($(".cycsearchboxeslandingcontainerins .cycsearchyearins").val().startsWith('Select') == true){
	 $(".cycsearchboxeslandingcontainerins .cycsearchyearins").css("color","#E32028");   
  }
  if($(".cycsearchboxeslandingcontainerins .cycsearchmakeins").val().startsWith('Select') == true){
	 $(".cycsearchboxeslandingcontainerins .cycsearchmakeins").css("color","#E32028");   
  }
  if($(".cycsearchboxeslandingcontainerins .cycsearchmodelins").val().startsWith('Select') == true){
	 $(".cycsearchboxeslandingcontainerins .cycsearchmodelins").css("color","#E32028");   
  }	
}
